module.exports = __webpack_public_path__ + "img/success_OLD_1.9fef8ffb.gif";